import type { PodBrand } from '@/types/pod'

/**
 * The Cornwall Steel Buildings pod — branding layer (browser side).
 *
 * THE OPERATOR'S OWN SITE (cornwallsteelbuildings.co.uk, run by Autaimate).
 * Embedded as an iframe from chat.cornwallsteelbuildings.co.uk on that site
 * only (EMBED_PARENT_ORIGIN = https://cornwallsteelbuildings.co.uk).
 *
 * NO PARTNER DETAILS, ANYWHERE IN THIS FILE. The building partner is never
 * named by this assistant (operator's decision, 9 Oct 2026), and the contact
 * routes are the site's own: the tracked number and the site's inbox.
 * tests/csb-pod.test.ts fails the build if the partner's name or any of their
 * contact details appears here.
 *
 * PALETTE. Lifted from the site's own tokens in src/styles/global.css so the
 * assistant reads as part of the page: juniper green, ochre accent, the pale
 * "wash" surface and the ink text colour.
 *
 * builtByForedesk is OFF. This is the front desk of the operator's own trading
 * site, not a pitch asset; a product credit would read as an advert on it.
 */
export const csbPod: PodBrand = {
  id: 'csb',
  brandName: 'Cornwall Steel Buildings',
  productName: 'Cornwall Steel Buildings',
  assistantName: 'Jago',
  tagline: 'Steel buildings for Cornwall and Devon',
  roleLabel: 'steel buildings assistant',
  welcomeIntro:
    "Thinking about a steel building? Ask me what it's likely to cost, how big it needs to be, what goes underneath it, or where you stand on planning. Farm buildings, stables, industrial units, and garages and workshops at the house — anywhere in Cornwall and Devon.",
  starters: [
    'Roughly what does a steel building cost?',
    'Is the concrete base included in the price?',
    'Do I need planning permission for a farm building?',
    'What do you need from me to get a price?',
  ],
  inputPrompt: 'Ask Jago about your building',
  footerNote:
    "Jago answers from this site's own pages. Anything it can't answer comes to Cornwall Steel Buildings, and you get a reply the same day.",
  theme: {
    '--color-brand-primary': '47 74 60', // juniper #2F4A3C
    '--color-brand-primary-hover': '34 55 44', // juniper-deep #22372C
    '--color-brand-accent': '196 135 43', // ochre #C4872B
    '--color-surface-base': '241 243 241', // wash #F1F3F1
    '--color-surface-raised': '255 255 255',
    '--color-surface-subtle': '241 243 241',
    '--color-text-primary': '30 43 36', // ink #1E2B24
    '--color-text-muted': '94 106 100', // muted #5E6A64
    '--color-text-danger': '178 47 47',
    '--color-border-subtle': '214 218 215', // rule #D6DAD7
  },
  // The site's own privacy notice covers this chat (it is updated in the
  // same change that embeds it). See PodBrand.privacyUrl for why.
  privacyUrl: 'https://cornwallsteelbuildings.co.uk/privacy/',
  contact: {
    phone: '01872 306707',
    email: 'info@cornwallsteelbuildings.co.uk',
  },
}
